jQuery(document).ready(function ($) {
  var $sliders = $(".image-grid.image-grid--overflow");
  if (!$sliders.length) {
    return;
  }

  var widthFractions = {
    "image-grid-slide--fifth": 0.2,
    "image-grid-slide--3": 0.25,
    "image-grid-slide--4": 1 / 3,
    "image-grid-slide--6": 0.5,
    "image-grid-slide--8": 2 / 3,
    "image-grid-slide--12": 1,
  };

  var slickSettings = {
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    infinite: true,
    variableWidth: true,
    slidesToScroll: 1,
    // prevent additional div - click bug
    rows: 0,
  };

  function getSlideFraction($slide) {
    var fraction = null;
    Object.keys(widthFractions).some(function (cls) {
      if ($slide.hasClass(cls)) {
        fraction = widthFractions[cls];
        return true;
      }
    });
    return fraction;
  }

  function applySlideWidths($slider) {
    var $container = $slider.closest(".container");
    // Row negative margins expand the slider to the container's padding
    // edge (innerWidth). Using .width() left a gutter-sized gap so the
    // next slide peeked into the viewport.
    var $list = $slider.children(".slick-list");
    var totalWidth =
      ($list.length && $list.width()) ||
      $slider.width() ||
      $container.innerWidth();

    $slider.find(".image-grid-slide").each(function () {
      var $slide = $(this);
      var fraction = getSlideFraction($slide);
      if (fraction === null) {
        return;
      }
      $slide.css("width", Math.round(totalWidth * fraction) + "px");
    });
  }

  function clearHoverState($slider) {
    $slider
      .find(".image-grid-slide")
      .removeClass(
        "is-hover-focus is-hover-neighbor is-hover-neighbor-left is-hover-neighbor-right is-hover-near is-hover-near-left is-hover-near-right"
      );
  }

  function bindHoverScale($slider) {
    if ($slider.data("image-grid-hover-bound")) {
      return;
    }
    // Dock-style magnification is pointer-hover only
    if (
      window.matchMedia &&
      !window.matchMedia("(hover: hover) and (pointer: fine)").matches
    ) {
      return;
    }
    $slider.data("image-grid-hover-bound", true);

    $slider.on("mouseenter.imageGridHover", ".image-grid-slide", function () {
      var $slide = $(this);
      var $prev = $slide.prev(".image-grid-slide");
      var $next = $slide.next(".image-grid-slide");

      clearHoverState($slider);
      $slide.addClass("is-hover-focus");
      $prev.addClass("is-hover-neighbor is-hover-neighbor-left");
      $next.addClass("is-hover-neighbor is-hover-neighbor-right");
      $prev.prev(".image-grid-slide").addClass("is-hover-near is-hover-near-left");
      $next.next(".image-grid-slide").addClass("is-hover-near is-hover-near-right");
      $slider.slick("slickPause");
    });

    $slider.on("mouseleave.imageGridHover", ".image-grid-slide", function (e) {
      var $nextSlide = $(e.relatedTarget).closest(".image-grid-slide");
      if ($nextSlide.length && $slider.has($nextSlide).length) {
        return;
      }
      clearHoverState($slider);
      $slider.slick("slickPlay");
    });
  }

  function initSlider($slider) {
    if ($slider.hasClass("slick-initialized")) {
      applySlideWidths($slider);
      $slider.slick("setPosition");
      return;
    }
    applySlideWidths($slider);
    $slider.slick(slickSettings);
    // Cloned slides need the same widths after init
    applySlideWidths($slider);
    $slider.slick("setPosition");
    bindHoverScale($slider);
  }

  function manageSliders() {
    $sliders.each(function () {
      initSlider($(this));
    });
  }

  manageSliders();

  var resizeTimeout;
  $(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(manageSliders, 150);
  });
});
